module.exports = __webpack_public_path__ + "open-sans-italic-light.c7bda75b1d04dd8c00f5.woff";


//////////////////
// WEBPACK FOOTER
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/assets/fonts/google/open-sans-italic-light.woff
// module id = OF2T
// module chunks = 1